/**
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019-2022, Bulb Inc. For more information, please email contact@hellobulb.com.
 */

import { AeroModule } from 'src/aero/aero.module';
import { CommonModule } from '@angular/common';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { MacmillanBookDialogComponent } from './macmillan-book-dialog.component';
import { SVGIconModule } from '../svg-icon/svg-icon.module';

/**
 * Module housing our Macmillan dialogs and related Macmillan feature functionality
 */
@NgModule({
  declarations: [
    MacmillanBookDialogComponent,
  ],
  imports: [
    AeroModule,
    CommonModule,
    DynamicDialogModule,
    SVGIconModule,
    TranslocoModule,
  ],
})
export class BulbMacmillanModule { }
